/**
 * SGKC007A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface TankatableBasicInfo {

    /**
     * 単価表コード
     */
    tankatableCode?: string;
    /**
     * 会社コード
     */
    companycode?: string;
    /**
     * 会社名
     */
    companyname?: string;
    /**
     * エネルギー種別コード
     */
    energyClscode?: string;
    /**
     * エネルギー種別名称
     */
    energyClsname?: string;
    /**
     * ＬＰ販売形態コード
     */
    lpSalesformcode?: string;
    /**
     * ＬＰ販売形態名称
     */
    lpSalfrmAname?: string;
    /**
     * プロダクトコード
     */
    prdCode?: string;
    /**
     * プロダクト正式名称
     */
    prdAname?: string;
    /**
     * スライド調整単価コード
     */
    slideadjustmentunitpriceCode?: string;
    /**
     * スライド調整単価名称
     */
    slideadjustmentunitpriceAname?: string;
    /**
     * 地点群供給地点区分番号
     */
    locationgroupSuppntDivisionnumber?: string;
    /**
     * 地点群供給地点区分名称
     */
    locationgroupSuppntDivisionname?: string;
    /**
     * 単価表名称
     */
    tankatableAname?: string;
    /**
     * 単価表メモ
     */
    tankatableMemo?: string;
    /**
     * 単価表説明
     */
    tankatableExplanation?: string;
}

